import { useCallback } from 'react';
import { useQuery } from '@apollo/client';

import { CvBanner as CvBannerView } from './cv-banner';
import { useCvBonusInfo } from '../../../../../hooks';
import { EcpProfileResponse } from '../../../../../graphql/ecp-locator/models';
import { GET_ECP_PROFILE } from '../../../../../graphql/ecp-locator/queries';
import { useCvInfoModal } from '../../../../../hooks/use-cv-info-modal';
import { CvBannerContainerProps } from './cv-banner.models';

export const CvBanner = ({ withoutPadding, rootClasses }: CvBannerContainerProps): JSX.Element => {
  const { data } = useQuery<EcpProfileResponse>(GET_ECP_PROFILE, { fetchPolicy: 'no-cache' });
  const isCvAvailable = data?.profile?.servicesAvailability?.controlVisitAvailability ?? false;
  const { cvBonusPoints, cvBonusEndDate, fromDays, toDays, code, isCvPeriodActive, isLoading } = useCvBonusInfo(isCvAvailable);
  const { handleCvDetailsClick } = useCvInfoModal({
    points: cvBonusPoints,
    fromDays,
    toDays,
    endDate: cvBonusEndDate,
    code,
    isLoading,
  });
  const isShowBanner = isCvAvailable && !!cvBonusPoints && !!cvBonusEndDate && isCvPeriodActive;

  const handleAction = useCallback((): void => handleCvDetailsClick(), [handleCvDetailsClick]);

  return (
    <>{isShowBanner && (
      <CvBannerView
        onAction={handleAction}
        points={cvBonusPoints}
        date={cvBonusEndDate}
        withoutPadding={withoutPadding}
        rootClasses={rootClasses}
      />
    )}</>
  );
};
